// src/Components/LocationJumpToolbar.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';                 // ✅ 공용 api 사용
import '../css/location-jump-toolbar.css';

/**
 * 위치의 층 목록만 보여주고, 선택하면 onSelectFloor를 호출하거나 (옵션) 라우팅.
 *
 * props:
 * - locationName: string (필수) — 어떤 위치의 층들을 보여줄지
 * - currentFloorName?: string — 현재 선택된 층 (하이라이트용)
 * - onSelectFloor?: (floorName: string) => void — 라우팅 없이 부모에서 상태로 교체할 때 사용
 * - useNavigation?: boolean (기본 false) — true면 직접 navigate로 URL을 바꿈
 */
export default function LocationJumpToolbar({
  locationName,
  currentFloorName = '',
  onSelectFloor,
  useNavigation = false,
}) {
  const [floors, setFloors] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!locationName) {
      setFloors([]);
      setLoading(false);
      return;
    }

    const load = async () => {
      setLoading(true);
      try {
        // ✅ Authorization 헤더는 api 인터셉터가 자동으로 부착됨
        const res = await api.get('/floors', {
          params: { location: locationName },
        });
        setFloors(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        console.error('floors 로드 실패:', e?.response || e);
        setFloors([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [locationName]);

  const go = (floorName) => {
    if (!floorName) return;
    if (useNavigation) {
      navigate(
        `/locations/${encodeURIComponent(locationName)}/floors/${encodeURIComponent(floorName)}`
      );
    } else {
      onSelectFloor?.(floorName);
    }
  };

  return (
    <div className="ljt-overlay">
      <div className="ljt-ribbon">
        {loading ? (
          <>
            <span className="ljt-chip ljt-chip--skeleton" />
            <span className="ljt-chip ljt-chip--skeleton" />
            <span className="ljt-chip ljt-chip--skeleton" />
          </>
        ) : floors.length === 0 ? (
          <div className="ljt-empty">“{locationName}”에 등록된 층이 없습니다.</div>
        ) : (
          floors.map((f) => {
            const isActive =
              currentFloorName &&
              f?.name &&
              currentFloorName.toLowerCase() === f.name.toLowerCase();
            return (
              <button
                key={f.name}
                type="button"
                className={`ljt-chip ${isActive ? 'is-active' : ''}`}
                title={f.name}
                onClick={() => go(f.name)}
              >
                {f.name}
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
